export enum MaintenanceStatus {
  Pending = 1,
  Approved = 2,
  Complete = 3,
  Overdue = 4,
  Rejected = 5
}
